<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <user-form :create="true" @saved="gotoUser"></user-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            gotoUser(user) {
                this.$router.push({name: 'user', params: {id: user.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// UserCreate.vue?278954e6